import { z } from "zod";
import type { TFunction } from "i18next";

export function createShiftTradeSchema({ t }: { t: TFunction }) {
    return z.object({
        reason: z.string().min(1, { message: t("required-reason") })
    });
}

export type ShiftTradeFormValues = z.infer<ReturnType<typeof createShiftTradeSchema>>;
